module.exports = __webpack_public_path__ + "img/top-bar.3e00c9bc.png";